import { memo } from 'react';
import { Box, Badge, ButtonBase } from '@material-ui/core';
import { makeStyles, styled } from '@material-ui/core/styles';
import { ThumbUpAltOutlined } from '@material-ui/icons';

const StyleBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -8,
    backgroundColor: '#ff7270',
    color: theme.palette.font.white,
    fontFamily: 'NotoSans-Medium'
  }
}))

const useStyles = makeStyles((theme) => ({
  thumbUpIcon: {
    fontSize: '2rem',
    color: theme.palette.primary.main,
  },
  thumbUpBox: {
    position: 'relative',
  },
}));


function AppreciationTotal({ total, onClick }) {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" mr="1.875rem" pr="0.75rem">
      <ButtonBase className={classes.thumbUpBox} onClick={onClick} id="ThumbUp-header-total">
        <StyleBadge badgeContent={total} color="secondary">
          <ThumbUpAltOutlined className={classes.thumbUpIcon} />
        </StyleBadge>
      </ButtonBase>
    </Box>
  );
}

export default memo(AppreciationTotal);
